/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function SurveyIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-survey">
        <g id="Group 83 Copy 2">
          <g id="Group 82">
            <g id="Group 80 Copy 2">
              <g id="Group 79 Copy 2">
                <g id="Group 78">
                  <g id="Group 76 Copy 2">
                    <g id="Group 74 Copy 2">
                      <g id="Group 72 Copy 2">
                        <g id="Group 70 Copy 2">
                          <g id="Group 68 Copy 2">
                            <g id="Group 66 Copy 2">
                              <g id="Group 65 Copy 2">
                                <g id="Group 63 Copy 2">
                                  <g id="Group 61 Copy 2">
                                    <g id="Group 59 Copy 3">
                                      <g id="icon-legal and finance copy">
                                        <g id="Group 58 Copy 2">
                                          <g id="icon-journey-course">
                                            <circle
                                              id="Oval"
                                              cx="78.5"
                                              cy="78.5"
                                              r="77.5"
                                              fill={mainColor}
                                              stroke="white"
                                              strokeWidth="2"
                                            />
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="survey">
          <g id="Group 85">
            <path
              id="Shape"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M97.111 41.3334H104.555C108.661 41.3334 112 44.6222 112 48.6666V114.667C112 118.711 108.661 122 104.556 122H52.4445C48.3387 122 45 118.711 45 114.667V48.6666C45 44.6222 48.3387 41.3334 52.4443 41.3334H59.8888C59.9618 41.3334 60.0285 41.3515 60.0955 41.3696C60.1337 41.3799 60.1719 41.3903 60.2114 41.3973C60.9638 39.2351 63.0251 37.6666 65.4722 37.6666H71.0937C72.8422 35.3822 75.5902 34 78.5 34C81.4098 34 84.1578 35.3822 85.9061 37.6666H91.5277C93.9747 37.6666 96.0359 39.2353 96.7884 41.3973C96.8279 41.3903 96.8661 41.3799 96.9043 41.3696C96.9713 41.3515 97.0381 41.3334 97.111 41.3334ZM67.7499 49H90.2497C92.3169 49 93.9996 47.3546 94 45.3334V43.5C94 42.4883 93.1594 41.6666 92.125 41.6666H85.4599C84.7934 41.6666 84.1764 41.3193 83.8394 40.7553C82.8123 39.0295 81.0032 38 79 38C76.9968 38 75.1879 39.0294 74.1606 40.7553C73.8236 41.3193 73.2066 41.6666 72.5401 41.6666H65.875C64.8404 41.6666 64 42.4885 64 43.5V45.3334C64 47.3546 65.6827 49 67.7499 49Z"
              fill={secondaryColor}
            />
            <g id="check-mark">
              <path
                id="Path"
                d="M75.687 97.332C73.615 99.404 70.253 99.404 68.182 97.332L56.554 85.704C54.482 83.633 54.482 80.271 56.554 78.2C58.625 76.128 61.987 76.128 64.059 78.2L70.987 85.127C71.51 85.649 72.359 85.649 72.883 85.127L91.642 66.368C93.713 64.296 97.075 64.296 99.147 66.368C100.142 67.363 100.701 68.713 100.701 70.12C100.701 71.527 100.142 72.877 99.147 73.872L75.687 97.332Z"
                fill={mainColor}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

SurveyIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
SurveyIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(SurveyIcon);
memoized.displayName = 'SurveyIcon';
export default memoized;
